import { get } from '../../utils/http';
import checkStatus from '../../utils/checkStatus';
import * as constants from './connections-stats-constants';

export function refreshConnectionsStats() {
  return dispatch => {
    dispatch({ type: constants.REFRESH_CONNECTIONS_STATS_STARTING });
    return get('/proxy/connections/stats')
      .then(checkStatus)
      .then(res => res.json())
      .then(res => dispatch({ type: constants.REFRESH_CONNECTIONS_STATS, payload: res }));
  };
}



// WEBPACK FOOTER //
// ./src/app/stores/connections-stats/connections-stats-actions.js